import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_down",
  "use": "icon_down-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_down\"><path d=\"M12.4696 18.7835C11.3367 17.2401 12.3819 15 14.2348 15H33.7652C35.6181 15 36.6633 17.2401 35.5304 18.7835L25.7652 32.0875C24.8722 33.3042 23.1278 33.3042 22.2348 32.0875L12.4696 18.7835Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol